export default {
  bagFees: "Suppléments bagages susceptibles d'être appliqués",
}
